import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { withTranslation } from 'react-i18next';
import {
  MEDICATION_APPLICATION_STATUS,
  MEDICATION_STATUS_ENUM,
} from '../../../shared/utils/constants';

const MedicationStatusSelector = ({ input, t, ...rest }) => {
  const color = { color: '#646777' };
  const fill = { fill: '#646777' };

  return (
    <MuiThemeProvider>
      <Fragment>
        <RadioButtonGroup
          {...input}
          {...rest}
          valueSelected={input.value}
          onChange={(event, value) => input.onChange(value)}
          className="radio-button-selector"
        >
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={MEDICATION_STATUS_ENUM.PENDING}
            label={t(
              `medication_application.status.${MEDICATION_APPLICATION_STATUS.PENDING}`
            )}
          />
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={MEDICATION_STATUS_ENUM.APPLIED}
            label={t(
              `medication_application.status.${MEDICATION_APPLICATION_STATUS.APPLIED}`
            )}
          />
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={MEDICATION_STATUS_ENUM.CANCELED}
            label={t(
              `medication_application.status.${MEDICATION_APPLICATION_STATUS.CANCELED}`
            )}
          />
        </RadioButtonGroup>
      </Fragment>
    </MuiThemeProvider>
  );
};

MedicationStatusSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MedicationStatusSelector);
